import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import analytics from './plugins/analytics'

const app = createApp(App)

app.use(router)
app.use(store)
app.use(analytics)

app.mount('#app')
